(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-gift-controller"] && !Shopify.designMode) return;
  try {
    const cartMessageManager = window.cartMessageManager || (() => {
    const state = {
      isGift: false,
      giftNote: '',
      customerNote: ''
    };

    const initialized = {
      isGift: false,
      giftNote: false,
      customerNote: false
    };

    let saveTimeout;

    const composeOrderNote = () => {
      const customerNote = state.customerNote.trim();

      if (!state.isGift) {
        return customerNote;
      }

      const parts = [
        'Gift details',
        'This is a gift'
      ];

      if (state.giftNote.trim() !== '') {
        parts.push(`Gift note: ${state.giftNote.trim()}`);
      }

      if (customerNote !== '') {
        parts.push('', 'Additional order note', customerNote);
      }

      return parts.join('\n');
    };

    const syncGiftElement = (element) => {
      if (!element.checkbox || !element.noteField || !element.noteWrapper) {
        return;
      }

      element.checkbox.checked = state.isGift;
      element.noteField.value = state.giftNote;
      element.noteWrapper.hidden = !state.isGift;
      element.noteField.disabled = !state.isGift;

      if (element.hiddenCheckbox) {
        element.hiddenCheckbox.disabled = state.isGift;
      }

      if (element.hiddenNote) {
        element.hiddenNote.disabled = state.isGift;
      }

      if (element.noteCounter && element.remainingCountTemplate && element.maxLength) {
        const remaining = Math.max(element.maxLength - element.noteField.value.length, 0);
        element.noteCounter.textContent = element.remainingCountTemplate.replace('__COUNT__', remaining);
      }
    };

    const syncManagedNoteElement = (element) => {
      if (!element.noteField || !element.hiddenNoteField) {
        return;
      }

      element.noteField.value = state.customerNote;
      element.hiddenNoteField.value = composeOrderNote();
    };

    const syncAll = () => {
      document.querySelectorAll('cart-gift').forEach(syncGiftElement);
      document.querySelectorAll('managed-cart-note').forEach(syncManagedNoteElement);
    };

    const ensureInitialState = (partialState) => {
      for (const [key, value] of Object.entries(partialState)) {
        if (value === null || value === undefined || initialized[key]) {
          continue;
        }

        state[key] = key === 'isGift' ? Boolean(value) : String(value);
        initialized[key] = true;
      }

      syncAll();
    };

    const setState = (partialState) => {
      for (const [key, value] of Object.entries(partialState)) {
        if (value === null || value === undefined) {
          continue;
        }

        state[key] = key === 'isGift' ? Boolean(value) : String(value);
        initialized[key] = true;
      }

      syncAll();
    };

    const save = () => {
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          note: composeOrderNote(),
          attributes: {
            is_gift: state.isGift ? 'Yes' : '',
            gift_note: state.isGift ? state.giftNote : '',
            customer_order_note: state.customerNote
          }
        }),
        keepalive: true
      }).catch(() => {});
    };

    const queueSave = () => {
      if (saveTimeout) {
        clearTimeout(saveTimeout);
      }

      saveTimeout = setTimeout(save, 250);
    };

    return {
      ensureInitialState,
      setState,
      queueSave
    };
  })();

  window.cartMessageManager = cartMessageManager;

  class CartGift extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
    }

    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"][name="attributes[is_gift]"]');
      this.hiddenCheckbox = this.querySelector('input[type="hidden"][name="attributes[is_gift]"]');
      this.noteField = this.querySelector('textarea[name="attributes[gift_note]"]');
      this.hiddenNote = this.querySelector('input[type="hidden"][name="attributes[gift_note]"]');
      this.noteWrapper = this.querySelector('.cart-gift__fields');
      this.noteCounter = this.querySelector('.form-control__max-characters-count');
      this.remainingCountTemplate = this.dataset.remainingCountTemplate || '__COUNT__';
      this.maxLength = parseInt(this.noteField?.getAttribute('maxlength') || '0', 10);

      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);
      cartMessageManager.ensureInitialState({
        isGift: this.checkbox?.checked,
        giftNote: this.noteField?.value ?? ''
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.onInput);
    }

    onChange(event) {
      if (event.target === this.checkbox) {
        cartMessageManager.setState({
          isGift: this.checkbox.checked,
          giftNote: this.noteField?.value ?? ''
        });
        cartMessageManager.queueSave();
      }
    }

    onInput(event) {
      if (event.target === this.noteField) {
        if (this.maxLength > 0 && this.noteField.value.length > this.maxLength) {
          this.noteField.value = this.noteField.value.slice(0, this.maxLength);
        }

        cartMessageManager.setState({
          isGift: this.checkbox?.checked ?? false,
          giftNote: this.noteField.value
        });
        cartMessageManager.queueSave();
      }
    }
  }

  if (!window.customElements.get('cart-gift')) {
    window.customElements.define('cart-gift', CartGift);
  }

  class ManagedCartNote extends HTMLElement {
    constructor() {
      super();
      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
    }

    connectedCallback() {
      this.noteField = this.querySelector('textarea[name="attributes[customer_order_note]"]');
      this.hiddenNoteField = this.querySelector('input[type="hidden"][name="note"]');

      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onInput);

      cartMessageManager.ensureInitialState({
        customerNote: this.noteField?.value ?? ''
      });
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('input', this.onInput);
    }

    onChange(event) {
      if (event.target === this.noteField) {
        cartMessageManager.setState({ customerNote: this.noteField.value });
        cartMessageManager.queueSave();
      }
    }

    onInput(event) {
      if (event.target === this.noteField) {
        cartMessageManager.setState({ customerNote: this.noteField.value });
        cartMessageManager.queueSave();
      }
    }
  }

  if (!window.customElements.get('managed-cart-note')) {
    window.customElements.define('managed-cart-note', ManagedCartNote);
  }
  } catch(e) { console.error(e); }
})();

})();
